import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';
import LoadingSpinner from '../components/LoadingSpinner';

function Gallery() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(`${API_URL}/api/images`);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Failed to fetch images');
        }

        setImages(data.results || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center py-20">
            <LoadingSpinner />
            <p className="mt-4 text-gray-400">加载图片中...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-900 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center py-20">
            <div className="p-4 bg-red-900/50 border border-red-500 text-red-300 rounded-lg">
              {error}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-blue-400 mb-4">AI艺术画廊</h1>
          <p className="text-gray-400">探索AI创作的艺术作品</p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {images.map((image) => (
            <div key={image.id} className="bg-gray-800 rounded-xl shadow-xl overflow-hidden transition-transform duration-200 hover:-translate-y-1">
              <div className="aspect-w-16 aspect-h-9">
                <img
                  src={image.url}
                  alt={image.prompt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4">
                <p className="text-sm text-gray-300">
                  提示词：{image.prompt}
                </p>
                <p className="text-xs text-gray-500 mt-2">
                  创建时间：{new Date(image.created_at).toLocaleDateString()}
                </p>
                <div className="mt-4">
                  <a
                    href={image.url}
                    download="ai-artwork.png"
                    className="inline-flex items-center px-4 py-2 text-sm font-medium text-blue-400 hover:text-blue-300 transition-colors duration-200"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    下载图片
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {images.length === 0 && (
          <div className="text-center py-20">
            <p className="text-gray-400">暂无图片</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Gallery;
